import React from "react";
import logoServizi from "../Assets/Img/logo SL_logo orizzontale 2_grey.png";


function FooterSmall() {
  return (
    <footer className="it-footer py-3" style={{backgroundColor:"#33383c"}}>
      <div className="container">
        <div className="row">
          <div className="col-5">
            <p className="mb-2 small text-white">
              <strong>Email:</strong>
              <br />
              <a
                href="mailto:smartwelfare@comune.bari.it"
                className="text-white"
              >
                smartwelfare@comune.bari.it
              </a>
              <br />
              <a
                href="mailto:serviziallapersona.bari@servizilocalispa.it"
                className="text-white"
              >
                serviziallapersona.bari@servizilocalispa.it
              </a>
            </p>
          </div>
          <div className="col-4">
            <p className="mb-2 small text-white">
              <strong>Orari:</strong>
              <br />
              Lun, Mer, Ven: 09:00 – 13:00
              <br />
              Gio: 15:00 – 18:00
            </p>
          </div>
          <div className="col-3">
            <p className="mb-2 small text-white">
              <strong>Telefono:</strong>
              <br />
              080.8407737
            </p>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12 text-center">
            <img
              alt="Logo Servizi Locali"
              height="70"
              src={logoServizi}
              style={{ verticalAlign: "middle" }}
            />
            <p className="text-white">
              Powered by Servizi Locali S.P.A. © 2022 - 2026
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterSmall;
